!function(e){"function"==typeof define&&define.amd?define('jqueryui-amd/version',["jquery"],e):e(jQuery)}(function(e){return e.ui=e.ui||{},e.ui.version="1.12.1"});
